import { render, staticRenderFns } from "./DiscoveryAnalysis.vue?vue&type=template&id=593023be&scoped=true&"
import script from "./DiscoveryAnalysis.vue?vue&type=script&lang=js&"
export * from "./DiscoveryAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryAnalysis.vue?vue&type=style&index=0&id=593023be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593023be",
  null
  
)

export default component.exports